import { Avatar, Box, Flex, Text } from '@chakra-ui/react';
import type { InboxThread } from './types';
import { UnreadBadge } from './UnreadBadge';
import { getAvatarColorFromName } from '@/lib/utils/avatarColor'; // Temporary  avatar color for mock data (no backend avatar yet)

const formatShort = (iso: string) => {
  const d = new Date(iso);
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  let hr = d.getHours();
  const min = String(d.getMinutes()).padStart(2, '0');
  const ampm = hr >= 12 ? 'pm' : 'am';
  hr = hr % 12 || 12;
  return `${mm}/${dd} ${hr}:${min} ${ampm}`;
};

type Props = {
  thread: InboxThread;
  isActive: boolean;
  onClick: () => void;
};

export const ThreadItem = ({ thread, isActive, onClick }: Props) => {
  const name = thread.customerName;
  const time = formatShort(thread.lastMessageAt);

  return (
    <Flex
      px="14px"
      py="14px"
      gap="12px"
      cursor="pointer"
      bg={isActive ? 'gray.50' : 'white'}
      _hover={{ bg: isActive ? 'gray.50' : 'gray.50' }}
      borderBottom="1px solid"
      borderColor="gray.100"
      onClick={onClick}
    >
      <Avatar
        name={name}
        size="sm"
        bg={getAvatarColorFromName(name)} 
        // Using deterministic color for mock data only (replace with real avatar when available)
        color="white"
      />

      <Box flex="1" minW="0">
        <Flex justify="space-between" align="center" gap="10px">
          <Text fontWeight="600" fontSize="sm" noOfLines={1}>
            {name}
          </Text>
          <Text fontSize="xs" color="gray.500" whiteSpace="nowrap">
            {time}
          </Text>
        </Flex>

        <Flex justify="space-between" align="center" mt="6px" gap="10px">
          <Text fontSize="sm" color="gray.700" noOfLines={1}>
            {thread.lastMessageSnippet}
          </Text>
          <UnreadBadge count={thread.unreadCount} />
        </Flex>
      </Box>
    </Flex>
  );
};
